<template>
  <div class="corporate-article" @click="select()">
    <div
      class="corporate-article-container"
      data-track-as="teaser.corporate"
      data-track-text-selector=".corporate-article-title"
    >
      <div class="corporate-article-category">
        <slot name="category"></slot>
      </div>
      <div class="corporate-article-title">
        <slot name="title"></slot>
      </div>
      <div class="corporate-article-description">
        <slot name="description"> </slot>
      </div>
      <div
        v-if="$slots.additionalInformation"
        class="corporate-article-additional-information"
      >
        <slot name="additionalInformation"></slot>
      </div>
      <div class="corporate-article-url">
        <a ref="aElement" :href="url" :target="target">
          <slot name="urlTitle"></slot>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SanitasMagazineCorporateArticle',

  props: {
    url: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
  },

  mounted() {
    const element = this.$el
    // add data elements to enable automatic 50% width
    if (!element.dataset.corporateArticleCount) {
      element.dataset.corporateArticleCount = 1
      element.dataset.corporateArticleOdd = 'odd'
    }
    if (
      element.nextElementSibling &&
      element.nextElementSibling.classList &&
      element.nextElementSibling.classList.contains('corporate-article')
    ) {
      element.dataset.corporateArticleLast = 'no'
      element.nextElementSibling.dataset.corporateArticleCount =
        parseInt(element.dataset.corporateArticleCount) + 1
      element.nextElementSibling.dataset.corporateArticleOdd =
        element.dataset.corporateArticleOdd === 'odd' ? 'even' : 'odd'
      if (element.nextSibling && element.nextSibling.textContent) {
        element.nextSibling.textContent = element.nextSibling.textContent.trim()
      }
    } else {
      element.dataset.corporateArticleLast = 'yes'
    }
  },

  methods: {
    select() {
      this.$refs.aElement.click()
    },
  },
}
</script>

<style lang="postcss" scoped>
.corporate-article {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 1;

  & > * {
  }

  &:hover {
    cursor: pointer;
    a {
      color: var(--c-primary-color-2);
      border-color: var(--c-primary-color-2);
    }
  }

  &.corporate-article[data-corporate-article-last='no'],
  &[data-corporate-article-last='yes'][data-corporate-article-odd='even'] {
    flex-basis: 50%;
    flex-grow: 0;
    max-width: calc(50% - 10px);
  }

  &.corporate-article[data-corporate-article-odd='even'] {
    margin-left: 20px;
  }

  @media (max-width: 860px) {
    &.corporate-article[data-corporate-article-last='no'],
    &[data-corporate-article-last='yes'][data-corporate-article-odd='even'] {
      flex-basis: 100%;
      max-width: 100%;
    }

    &.corporate-article[data-corporate-article-odd='even'] {
      margin-left: 0;
    }

    &.corporate-article[data-corporate-article-last='no']
      .corporate-article-container {
      margin-bottom: 0;
    }
  }

  &-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
    margin: 32px 0;
    padding: 24px;
    border: 1px solid var(--c-primary-neutral-1);
    overflow-wrap: break-word;
  }

  @media (max-width: 490px) {
    &-container {
      margin: 0 0 var(--spacing-8);
    }

    &.corporate-article[data-corporate-article-last='no']
      .corporate-article-container {
      margin-bottom: var(--spacing-8);
    }
  }

  &-category {
    font-size: 18px;
    color: var(--c-primary-neutral-1);
    padding-bottom: 10px;
  }

  &-title {
    font-size: 18px;
    line-height: 28px;
    font-weight: bold;
    color: var(--c-primary-neutral-1);
    padding-bottom: 30px;
  }

  &-description {
    font-size: 18px;
    line-height: 28px;
    color: var(--c-primary-neutral-1);
    margin-bottom: auto;
    padding-bottom: 30px;

    &.corporate-article-description {
      li,
      p {
        font-size: 18px;
        line-height: 28px;
        /* needed to switch from Faustina to Open Sans */
        font-family: inherit;
      }
      ul {
        padding-left: 17px;
        margin-bottom: 0;
      }
      ol {
        margin-top: 0;
      }
    }
  }

  &-additional-information {
    font-size: 18px;
    font-weight: bold;
    color: var(--c-primary-neutral-1);
    margin: auto 0 20px 0;
  }

  &-url {
    font-size: 18px;
    font-weight: bold;
    margin: 0;

    a {
      min-width: 146px;
      height: 50px;
      color: var(--c-primary-color-3);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding-left: 25px;
      padding-right: 25px;
      border: 1px solid var(--c-primary-color-3);
      border-radius: 25px;
    }
  }
}

@media (--xs) {
  .corporate-article {
    &-category {
      font-size: 20px;
    }

    &-title {
      font-size: 20px;
      line-height: 1.35;
    }

    &-description {
      font-size: 20px;
      line-height: 1.35;
      &.corporate-article-description {
        li,
        p {
          font-size: 20px;
          line-height: 1.35;
        }
      }
    }

    &-additional-information {
      font-size: 20px;
    }

    &-url {
      font-size: 20px;
    }
  }
}
</style>
